<template>
  <b-col cols="12" lg="6" class="py-sm-64 py-lg-0">
    <b-row align-v="center" align-h="center" class="h-100 mx-4 mx-sm-n32">
      <b-col
        cols="12"
        md="9"
        xl="7"
        class="col-xxxl-5 px-8 px-sm-0 pt-24 pb-48"
      >
        <h1 class="mb-0 mb-sm-24">Создать аккаунт</h1>
        <ValidationObserver v-slot="{ valid }">
          <b-form @submit="nextSlide" class="mt-16 mt-sm-32 mb-8">
            <validation-provider
              name="registerUsername"
              :rules="{ required: true }"
              v-slot="validationContext"
            >
              <b-form-group
                label="Имя :"
                label-for="registerUsername"
                class="mb-16"
              >
                <b-form-input
                  class="form-control"
                  v-model="username"
                  id="registerUsername"
                  type="text"
                  :state="getValidationState(validationContext)"
                  required
                ></b-form-input>
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="registerTel"
              :rules="{
                required: true,
                regex:
                  /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/,
              }"
              v-slot="validationContext"
            >
              <b-form-group
                label="Телефон :"
                label-for="registerTel"
                class="mb-16"
              >
                <b-form-input
                  name="tel"
                  class="form-control"
                  v-model="tel"
                  id="registerTel"
                  type="tel"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="registerEmail"
              :rules="{ required: true, email: true }"
              v-slot="validationContext"
            >
              <b-form-group
                label="Email :"
                label-for="registerEmail"
                class="mb-16"
              >
                <b-form-input
                  name="email"
                  class="form-control"
                  v-model="email"
                  id="registerEmail"
                  type="email"
                  :state="getValidationState(validationContext)"
                  required
                ></b-form-input>
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="registerPassword"
              :rules="'verify_password|required'"
              v-slot="validationContext"
            >
              <b-form-group
                label="Пароль :"
                label-for="registerPassword"
                class="mb-16"
              >
                <b-input-group>
                  <b-form-input
                    class="form-control"
                    v-model="password"
                    id="registerPassword"
                    v-bind:type="show_password ? 'text' : 'password'"
                    :state="getValidationState(validationContext)"
                    required
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      @click="show_password = !show_password"
                      variant="outline-primary"
                      size="sm"
                      ><i
                        v-if="!show_password"
                        class="hp-text-color-dark-0 iconly-Light-Show"
                      ></i>
                      <i
                        v-else
                        class="hp-text-color-dark-0 iconly-Light-Hide"
                      ></i>
                    </b-button>
                    <b-button
                      @click="password = gen_password(20)"
                      variant="outline-primary"
                      size="sm"
                      ><i class="hp-text-color-dark-0 iconly-Light-Password"></i
                    ></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="registerConfirmPassword"
              :rules="{ required: true }"
              v-slot="validationContext"
            >
              <b-form-group
                label="Подтверждения пароля :"
                label-for="registerConfirmPassword"
                class="mb-16"
              >
                <b-input-group>
                  <b-form-input
                    id="registerConfirmPassword"
                    v-bind:type="show_confirm_password ? 'text' : 'password'"
                    required
                    class="form-control"
                    :state="getValidationState(validationContext)"
                    v-model="confirm_password"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      @click="show_confirm_password = !show_confirm_password"
                      variant="outline-primary"
                      size="sm"
                      ><i
                        v-if="!show_confirm_password"
                        class="hp-text-color-dark-0 iconly-Light-Show"
                      ></i>
                      <i
                        v-else
                        class="hp-text-color-dark-0 iconly-Light-Hide"
                      ></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </validation-provider>

            <b-button
              :disabled="!valid"
              type="submit"
              variant="primary"
              class="w-100"
            >
              Далее
            </b-button>
          </b-form>
        </ValidationObserver>

        <div class="hp-form-info text-center">
          <span class="text-black-80 hp-text-color-dark-40 hp-caption mr-4">
            Уже есть аккаунт?
          </span>

          <b-link
            class="hp-cursor-pointer text-primary-1 hp-text-color-dark-primary-2 hp-caption"
            to="/pages/authentication/login"
          >
            Войти
          </b-link>
        </div>

        <div class="hp-form-info text-center mt-2">
          <span class="text-black-80 hp-text-color-dark-40 hp-caption mr-4">
            Нажимая на кнопку "Далее" вы соглашаетесь с условиями Раздела 9
            <a :href="privacy_link"
              >Политики ООО "Альтуэра" в отношении обработки персональных
              данных</a
            >
          </span>
        </div>

        <footer-item />
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BLink,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BInputGroupAppend,
  BInputGroup,
} from "bootstrap-vue";

import LeftItem from "../LeftItem.vue";
import FooterItem from "../FooterItem.vue";

export default {
  data() {
    return {
      username: this.$store.state.register.username,
      tel: this.$store.state.register.tel,
      email: this.$store.state.register.email,
      password: this.$store.state.register.password,
      confirm_password: "",

      show_password: false,
      show_confirm_password: false,
      privacy_link: process.env.VUE_APP_PRIVACY_POLICY,
    };
  },
  components: {
    BRow,
    BCol,
    BButton,
    BLink,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    LeftItem,
    FooterItem,
    BInputGroupAppend,
    BInputGroup,
  },
  methods: {
    gen_password(len) {
      var password = "";
      var upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      var cntUpper = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntUpper; i++) {
        password += upperCase.charAt(
          Math.floor(Math.random() * upperCase.length)
        );
      }

      var lowerCase = "abcdefghijklmnopqrstuvwxyz";
      var cntLower = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntLower; i++) {
        password += lowerCase.charAt(
          Math.floor(Math.random() * lowerCase.length)
        );
      }

      var numbers = "0123456789";
      var cntNumber = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntNumber; i++) {
        password += numbers.charAt(Math.floor(Math.random() * numbers.length));
      }

      var specSymbols = "!@#$%^&*";
      var cntSpec = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntSpec; i++) {
        password += specSymbols.charAt(
          Math.floor(Math.random() * specSymbols.length)
        );
      }
      var shuffled_password = password
        .split("")
        .sort(function () {
          return 0.5 - Math.random();
        })
        .join("");

      var symbols =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";

      while (shuffled_password.length < len) {
        shuffled_password += symbols.charAt(
          Math.floor(Math.random() * symbols.length)
        );
      }
      return shuffled_password;
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    nextSlide(event) {
      event.preventDefault();
      if (this.password != this.confirm_password) {
        alert("Пароли не совпадают");
        return;
      }
      this.$store.state.register.username = this.username;
      this.$store.state.register.tel = this.tel;
      this.$store.state.register.email = this.email;
      this.$store.state.register.password = this.password;
      this.$emit("nextSlide");
    },
  },
};
</script>
